module.exports = __webpack_public_path__ + "media/casana-scroll2_720p.dc2cd62d.webm";